/* All Yu — star cursor with a swinging tassel.
   Same tassel physics as the old katana cursor (flick + wind), new art.
   <script src="star-cursor.js" data-path="assets/brand/" data-scale="0.105"></script>
   Needs star-cursor.png + star-tassel.png in data-path.
   Skips touch screens and reduced-motion users; shows the normal text cursor in fields. */
(function () {
  if (!window.matchMedia ||
      !matchMedia('(hover: hover) and (pointer: fine)').matches ||
      matchMedia('(prefers-reduced-motion: reduce)').matches ||
      matchMedia('(prefers-contrast: more)').matches ||
      matchMedia('(forced-colors: active)').matches) return;

  var me = document.currentScript;
  var d = me ? me.dataset : {};
  var S = parseFloat(d.scale) || 0.105;
  var SWAY = d.sway != null ? parseFloat(d.sway) : 1;
  var WIND = d.wind != null ? parseFloat(d.wind) : 1;
  var PATH = d.path != null ? d.path : (me ? me.src.replace(/[^\/]*$/, '') : '');

  /* geometry measured from Andy's star render (see star-geometry.json) */
  var STAR_W = 472, TIP_X = 8, TIP_Y = 6;
  var TAS_W = 91, TAS_X = 420, TAS_Y = 538, PIV_X = 33, PIV_Y = 8;

  var css = document.createElement('style');
  css.textContent =
    'html,body,*{cursor:none !important}' +
    'input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]),textarea,select,[contenteditable]{cursor:text !important}' +
    '.star-cursor{position:fixed;top:0;left:0;z-index:2147483000;pointer-events:none;opacity:0;transition:opacity .25s ease;will-change:transform}' +
    '.star-cursor__rot{position:relative;transform-origin:' + (TIP_X * S) + 'px ' + (TIP_Y * S) + 'px;will-change:transform}' +
    '.star-cursor img{display:block;user-select:none;-webkit-user-drag:none}' +
    '.star-cursor__star{width:' + (STAR_W * S) + 'px;height:auto;filter:drop-shadow(0 3px 3px rgba(0,0,0,.30)) drop-shadow(0 0 1px rgba(0,0,0,.35))}' +
    '.star-cursor__tassel{position:absolute;width:' + (TAS_W * S) + 'px;height:auto;left:' + (TAS_X * S) + 'px;top:' + (TAS_Y * S) + 'px;' +
      'transform-origin:' + (PIV_X * S) + 'px ' + (PIV_Y * S) + 'px;will-change:transform;filter:drop-shadow(0 3px 3px rgba(0,0,0,.25))}';

  var wrap = document.createElement('div'); wrap.className = 'star-cursor'; wrap.setAttribute('aria-hidden', 'true');
  var rot = document.createElement('div'); rot.className = 'star-cursor__rot';
  var star = new Image(); star.className = 'star-cursor__star'; star.alt = ''; star.draggable = false; star.src = PATH + 'star-cursor.png';
  var tass = new Image(); tass.className = 'star-cursor__tassel'; tass.alt = ''; tass.draggable = false; tass.src = PATH + 'star-tassel.png';
  rot.appendChild(star); rot.appendChild(tass); wrap.appendChild(rot);

  var HOT = 'a,button,[role="button"],label,summary,select,.card,.color,.size,[data-cursor="hot"]';
  var FIELD = 'input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]),textarea,[contenteditable]';

  function mount() { document.head.appendChild(css); document.body.appendChild(wrap); run(); }
  /* hide the real pointer only once the star art has loaded: a slow, blocked or missing image keeps the normal cursor */
  var go = function () { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount(); };
  if (star.complete && star.naturalWidth) go(); else star.onload = go;

  function run() {
    var tipX = TIP_X * S, tipY = TIP_Y * S;
    var mx = innerWidth / 2, my = innerHeight / 2, pmx = mx, pvx = 0;
    var ang = 0, angVel = 0, t = 0, shown = false, inField = false;
    var hot = false, down = false, tilt = 0, scale = 1;

    addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!shown) { shown = true; if (!inField) wrap.style.opacity = '1'; }
    }, { passive: true });
    document.addEventListener('mouseover', function (e) {
      var el = e.target && e.target.closest ? e.target : null;
      hot = !!(el && el.closest(HOT));
      inField = !!(el && el.closest(FIELD));
      wrap.style.opacity = shown && !inField ? '1' : '0';
    });
    document.addEventListener('mouseleave', function () { wrap.style.opacity = '0'; shown = false; });
    addEventListener('mousedown', function () { down = true; angVel += 0.06; });
    addEventListener('mouseup', function () { down = false; });

    (function loop() {
      t += 1;
      /* hover: star tips forward; press: quick squeeze */
      var tiltTarget = hot ? -16 : 0, scaleTarget = down ? 0.86 : (hot ? 1.1 : 1);
      tilt += (tiltTarget - tilt) * 0.16; scale += (scaleTarget - scale) * 0.22;
      wrap.style.transform = 'translate(' + (mx - tipX) + 'px,' + (my - tipY) + 'px)';
      rot.style.transform = 'rotate(' + tilt + 'deg) scale(' + scale + ')';

      /* tassel pendulum — identical constants to the katana */
      var vx = mx - pmx, ax = vx - pvx;
      var drive = (-ax * 0.0048 - vx * 0.0010) * SWAY;
      var angAcc = -0.05 * ang - 0.115 * angVel + drive;
      angVel += angAcc; ang += angVel;
      if (ang > 1.15) { ang = 1.15; angVel *= -0.4; }
      if (ang < -1.15) { ang = -1.15; angVel *= -0.4; }
      var gust = 0.55 + 0.45 * Math.sin(t * 0.0055) * Math.sin(t * 0.0017 + 1.7);
      var wind = (Math.sin(t * 0.013) * 0.075 + Math.sin(t * 0.034 + 1.1) * 0.05 + Math.sin(t * 0.082 + 0.5) * 0.022) * gust * WIND - 0.05 * WIND;
      var skew = (Math.sin(t * 0.11) * 2.4 + Math.sin(t * 0.052 + 2.0) * 1.5) * gust * WIND;
      /* keep the tassel hanging straight down even while the star tilts */
      var comp = -tilt * Math.PI / 180;
      tass.style.transform = 'rotate(' + (ang + wind + comp) + 'rad) skewX(' + skew + 'deg)';
      pmx = mx; pvx = vx;
      requestAnimationFrame(loop);
    })();
  }
})();
